import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_ctx.modalShow)
    ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 0,
        modelValue: _ctx.modalShow,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalShow) = $event)),
        width: "1000",
        persistent: ""
      }, {
        default: _withCtx(() => [
          (_ctx.modelParameters)
            ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { "primary-title": "" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.modelParameters")), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.modelParameters)
                    ? (_openBlock(), _createBlock(_component_v_card_text, {
                        key: 0,
                        id: "modelParametersPrint"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            density: "compact",
                            modelValue: _ctx.modelParameters.fractionCutOffThreshold,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelParameters.fractionCutOffThreshold) = $event)),
                            variant: "outlined",
                            label: _ctx.$t('message.fractionCutOffThreshold')
                          }, null, 8, ["modelValue", "label"]),
                          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("message.car")), 1),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    density: "compact",
                                    modelValue: _ctx.modelParameters.maximumMinutesTravelTimeCar,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelParameters.maximumMinutesTravelTimeCar) = $event)),
                                    variant: "outlined",
                                    label: _ctx.$t('message.max')
                                  }, null, 8, ["modelValue", "label"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    density: "compact",
                                    modelValue: _ctx.modelParameters.travelTimeCarScale,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelParameters.travelTimeCarScale) = $event)),
                                    variant: "outlined",
                                    label: _ctx.$t('message.scale')
                                  }, null, 8, ["modelValue", "label"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    density: "compact",
                                    modelValue: _ctx.modelParameters.travelTimeCarConstant,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelParameters.travelTimeCarConstant) = $event)),
                                    variant: "outlined",
                                    label: _ctx.$t('message.constant')
                                  }, null, 8, ["modelValue", "label"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    density: "compact",
                                    modelValue: _ctx.modelParameters.travelTimeCarPower,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelParameters.travelTimeCarPower) = $event)),
                                    variant: "outlined",
                                    label: _ctx.$t('message.powerFactor')
                                  }, null, 8, ["modelValue", "label"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("message.pedestrian")), 1),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    density: "compact",
                                    modelValue: _ctx.modelParameters.maximumMinutesTravelTimePedestrian,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelParameters.maximumMinutesTravelTimePedestrian) = $event)),
                                    variant: "outlined",
                                    label: _ctx.$t('message.max')
                                  }, null, 8, ["modelValue", "label"])
                                ]),
                                _: 1
                              }),
                              true
                                ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        modelValue: _ctx.modelParameters.travelTimePedestrianScale,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelParameters.travelTimePedestrianScale) = $event)),
                                        variant: "outlined",
                                        label: _ctx.$t('message.scale')
                                      }, null, 8, ["modelValue", "label"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              true
                                ? (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        modelValue: _ctx.modelParameters.travelTimePedestrianConstant,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelParameters.travelTimePedestrianConstant) = $event)),
                                        variant: "outlined",
                                        label: _ctx.$t('message.constant')
                                      }, null, 8, ["modelValue", "label"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    density: "compact",
                                    modelValue: _ctx.modelParameters.travelTimePedestrianPower,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modelParameters.travelTimePedestrianPower) = $event)),
                                    variant: "outlined",
                                    label: _ctx.$t('message.powerFactor')
                                  }, null, 8, ["modelValue", "label"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("message.expressions")), 1),
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.modelFunctionTypeToUse")), 1),
                          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                          (_ctx.modelParameters.locationProperties.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("h5", null, _toDisplayString(_ctx.$tc("message.locationsType" + this.model.locationsType + "Name", 0)), 1),
                                _cache[11] || (_cache[11] = _createElementVNode("code", null, "LocationCode", -1)),
                                _cache[12] || (_cache[12] = _createElementVNode("code", null, "LocationGroupCode", -1)),
                                _cache[13] || (_cache[13] = _createElementVNode("code", null, "LocationClusterCode", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelParameters.locationProperties, (f, index) => {
                                  return (_openBlock(), _createElementBlock("code", { key: index }, _toDisplayString(f), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.modelParameters.locationGroupProperties.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("h5", null, _toDisplayString(_ctx.$tc("message.locationGroupsType" + this.model.locationGroupsType + "Name", 0)), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelParameters.locationGroupProperties, (f, index) => {
                                  return (_openBlock(), _createElementBlock("code", { key: index }, _toDisplayString(f), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.modelParameters.locationClusterProperties.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("h5", null, _toDisplayString(_ctx.$tc("message.locationClustersType" + this.model.locationClustersType + "Name", 0)), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelParameters.locationClusterProperties, (f, index) => {
                                  return (_openBlock(), _createElementBlock("code", { key: index }, _toDisplayString(f), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                          _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.ncalcMessage")), 1),
                          _createVNode(_component_v_table, { density: "compact" }, {
                            default: _withCtx(() => [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _cache[14] || (_cache[14] = _createElementVNode("th", { class: "text-left" }, null, -1)),
                                  _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t("message.description")), 1),
                                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("message.expression")), 1),
                                  _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("message.defaultValue")), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelParameters.functions, (f, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_icon, {
                                        onClick: ($event: any) => (_ctx.removeLine(f))
                                      }, {
                                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                          _createTextVNode("mdi-delete-circle-outline", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: f.description,
                                        "onUpdate:modelValue": ($event: any) => ((f.description) = $event),
                                        class: "parameterText",
                                        "hide-details": "",
                                        flat: "",
                                        "single-line": "",
                                        variant: "solo",
                                        "full-width": "",
                                        density: "compact"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: f.function,
                                        "onUpdate:modelValue": ($event: any) => ((f.function) = $event),
                                        class: "parameterText",
                                        "hide-details": "",
                                        flat: "",
                                        "single-line": "",
                                        variant: "solo",
                                        "full-width": "",
                                        density: "compact"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: f.defaultValue,
                                        "onUpdate:modelValue": ($event: any) => ((f.defaultValue) = $event),
                                        class: "parameterNumber",
                                        "hide-details": "",
                                        flat: "",
                                        "single-line": "",
                                        variant: "solo",
                                        "full-width": "",
                                        density: "compact"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_icon, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addLine()))
                          }, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                              _createTextVNode("mdi-plus-circle-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panels, { style: {"margin-top":"1em"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_title, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                            _createTextVNode("mdi-code-json", -1)
                                          ]))]),
                                          _: 1
                                        }),
                                        _cache[18] || (_cache[18] = _createTextVNode(" JSON", -1))
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("pre", null, _toDisplayString(this.encode()), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        variant: "text",
                        onClick: _ctx.save
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.save")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        variant: "text",
                        onClick: _ctx.close
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.cancel")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}